// dev environtment new
//export const WEB_API = "http://localhost:3222/admin-api/";
//export const WEB_API = "https://law.go.th:8443/backoffice/admin-api/";
//export const WEBSITE_URL = "http://law.go.th";
//export const EXPORT_PUBLIC = "https://law.go.th:8443/backoffice";
//export const VERSION_RELEASE = "2.8.1";

export const WEB_OPEN_ID = 'https://connect.egov.go.th/connect/authorize?response_type=code&client_id=6f6b7ab6-e862-46d2-89b4-142893cd1bc2&redirect_uri=https://backend.law.go.th/loginsuccess&scope=openid personal_token preferred_username citizen_id given_name family_name email phone_number email_require email_verified mobile_require ial_level_require'
// export const WEB_OPEN_ID_LOGOUT = 'https://connect.egov.go.th/connect/endsession?id_token_hint=&post_logout_redirect_uri=https://uatlaw.pkmconsultinggroup.com/backend#/logout'
export const WEB_OPEN_ID_LOGOUT = 'https://connect.egov.go.th/connect/endsession?id_token_hint=&post_logout_redirect_uri=https://backend.law.go.th/logout'
export const WEB_OPEN_ID_PASSWORD = 'https://connect.egov.go.th/Account/ChangePassword'
export const WEB_OPEN_ID_PROFILE = 'https://connect.egov.go.th/Account/Profile'

// dev environtment new
export const WEB_API = "https://dga-backoffice-upload.law.go.th/dga-backoffice-api/admin-api/";
export const WEB_API_UPLOAD = "https://dga-backoffice-upload.law.go.th/dga-backoffice-api/admin-api/"
export const WEB_API_ANSWER = "https://export.law.go.th/dga-backoffice-api-export/admin-api/"
export const WEBSITE_URL = "https://law.go.th";
export const EXPORT_PUBLIC = "https://law.go.th/backend";
export const VERSION_RELEASE = "5.0";

// dev prod  new
//export const WEB_API = "https://law.go.th:8443/backoffice/admin-api/";
// export const WEBSITE_URL = "https://law.go.th";
// export const EXPORT_PUBLIC = "https://law.go.th:8443/backoffice";
// export const VERSION_RELEASE = "1.6.0";